import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

export default Factory.extend({
  csvRow() {
    return this.id
  },
  firstName() {
    return faker.person.firstName()
  },
  lastName() {
    return faker.person.lastName()
  },
  gradePosition() {
    return faker.number.int({
      min: 1,
      max: 6,
    })
  },
  externalId() {
    return faker.number.int()
  },
  teacherEmail() {
    return faker.internet.exampleEmail()
  },
  schoolClassName() {
    return 'New School Class'
  },
})
